import axios, { AxiosResponse } from 'axios';

const url = '/services/isnaportal/open-api/debtor/filter';
const downloadUrl = '/services/isnaportal/open-api/debtor/generate';
const taxOrgUrl = '/services/isnaportal/open-api/tax-org/search?levels=1,2';
const printUrl = '/services/isnaportal/open-api/debtor/generate/pdf';

export const getInfo = (request: any): Promise<AxiosResponse> => {
    return axios.get(`${url}`, { params: request });
};

export const printDebtorInfo = (request: any): Promise<AxiosResponse> => {
    return axios.post(`${printUrl}`, request, {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/pdf',
        },
    });
};

export const getTaxOrg = () => {
    return axios.get(`${taxOrgUrl}`);
};

export const downloadDebtorInfo = (request: any): Promise<AxiosResponse> => {
    return axios.post(`${downloadUrl}`, request, {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/pdf',
        },
    });
};
